import * as React from 'react';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import { Avatar, FormGroup, Stack, TextField } from '@mui/material';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import YouTube from 'react-youtube';
import Service from '../../../util/Service';
import YoutubeTable from '../../tabela/YoutubeTable';
import ImgCompDialog from '../../util/ImgCompDialog';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const opts = {
    height: '300',
    width: '500',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
    //   autoplay: 1,
    },
  };

export default function EditarPaginaYoutube(props) {
    const { open, setOpen, doAction, tipo } = props;
    const [link, setLink]=React.useState('')
    const [tipoPalestra, setTipoPalestra]=React.useState('Presencial + Live')
    const [palestra, setPalestra]=React.useState('')
    const [fonte, setFonte]=React.useState('Livro')
    const [palestrante, setPalestrante]=React.useState('')
    const [avatar, setAvalar]=React.useState()
    const [local, setLocal]=React.useState('SGAS 909 SUL/ Asa Sul, Brasilia-DF Transmissão no YouTube e Facebook');
    const [videoId, setVideoId] = React.useState();
    const [openImagem, setOpenImagem] = React.useState(false);
    const [video, setVideo] = React.useState();

    const handleOk = () => {
        // console.log( jsonData );
        // let dado = {...jsonData}
        // dado.nome = 'header';

        const dado = {
            link: link,
            tipo: tipoPalestra,
            nome: palestra,
            fonte: fonte,
            palestrante: palestrante,
            avatar: avatar,
            local: local
        }
        if( video) dado.id = video.id;
        console.log( dado );
        
        Service.POST("/api/security/youtube", dado).then(r => {
            console.log(r);            
        }).catch(e =>{
            console.log( "erro--->", e )
            alert( e );            
        })
    };
    const handleLink = (e)=> {
        let uri = e.target.value;
        setLink(uri);
        let ext = uri.split("/");  
        let tp = null;
        if( ext.length > 1){
          tp = ext[ ext.length-1]
        }
        console.log( tp )
        if( tp === null)return;

        setVideoId(tp);
    }
    const handleAvatar=(r)=>{
        console.log( r );
        if( r){
            setAvalar(r.idArquivo);
        }
    }
    const handleActionTable=(r)=>{
        setVideo(r);
        setAvalar(r.avatar)
        setFonte(r.fonte);
        setLink( r.link);
        setLocal( r.local);
        setPalestra( r.nome );
        setPalestrante(r.palestrante);

        let uri = r.link;
        
        let ext = uri.split("/");  
        let tp = null;
        if( ext.length > 1){
          tp = ext[ ext.length-1]
        }
        console.log( tp )
        if( tp === null)return;

        setVideoId(tp);
    }
    return (
        <BootstrapDialog
            onClose={() => setOpen(false)}
            aria-labelledby="Editor-pagina"
            open={open}
            fullScreen
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="Editor-pagina">
                Incluir videos Youtube com filtro [{tipo}]
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid size={8}>
                        <FormGroup>
                            <Stack direction="row" spacing={1} >
                                <TextField id="id-url-youtube" label="Link Youtube" variant="standard" fullWidth 
                                    value={link} onChange={handleLink} 
                                />
                                <TextField id="id-tipo" label="Tipo da palestra" variant="standard" fullWidth 
                                    value={tipoPalestra} onChange={(e)=> setTipoPalestra(e.target.value)}
                                />
                            </Stack>
                            <Stack direction="row" spacing={1} >
                                <TextField id="id-descricao" label="Palestra" variant="standard" fullWidth 
                                    value={palestra} onChange={(e)=> setPalestra(e.target.value)}
                                />
                                <TextField id="id-fonte" label="Fonte" variant="standard" fullWidth 
                                    value={fonte} onChange={(e)=> setFonte(e.target.value)}
                                />
                            </Stack>
                            <Stack direction="row" spacing={2} sx={{ marginTop:2 }}>
                                <TextField id="id-palestrante" label="Palestrante" variant="standard" fullWidth
                                    value={palestrante} onChange={(e)=> setPalestrante(e.target.value)}
                                />
                                <Avatar
                                    alt="Remy Sharp"
                                    src={avatar? '/api/getAnexoById/'+avatar:""}
                                    sx={{ width: 56, height: 56, marginTop:5 }}
                                    />
                                    <IconButton aria-label="foto" onClick={()=> setOpenImagem(true)}>
                                        <PersonSearchIcon />
                                    </IconButton>
                            </Stack>
                            <TextField id="id-local" label="Local" variant="standard" 
                                value={local} onChange={(e)=> setLocal(e.target.value)}
                            />                            
                            <Button autoFocus onClick={handleOk}>
                                Adicionar Video
                            </Button>
                        </FormGroup>
                    </Grid>
                    <Grid size={4}>
                        {videoId && <YouTube 
                            videoId={videoId} 
                            opts={opts} 
                        />}
                        {!videoId && <p>Youtube</p>}
                    </Grid>
                    <Grid size={12}>
                        <YoutubeTable tipo={tipo} doAction={handleActionTable}/>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={()=>setOpen(false)}>
                    Ok
                </Button>
            </DialogActions>
            <ImgCompDialog open={openImagem} setOpen={setOpenImagem} action={handleAvatar}/>
        </BootstrapDialog>
    )
}